// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"ConsentCheckbox_checkboxLabel__OE0Tu","container":"ConsentCheckbox_container__e4IUz","checkboxContainer":"ConsentCheckbox_checkboxContainer__6S8Qq"};